import { Tochi } from "./tochi";

const api = {
  tochi: Tochi,
};

export default api;
